import type { ChangeEvent } from 'react'
import { forwardRef, useEffect, useState } from 'react'
import { Box, Textarea as MantineTextArea } from '@mantine/core'

import type { TextareaProps } from '@/components/Textarea/Textarea.types'

import classes from './Textarea.module.css'

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ containerProps, onChange, value, ...props }, ref) => {
    const [localValue, setLocalValue] = useState(value || '')

    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
      onChange?.(event)

      setLocalValue(event.currentTarget.value)
    }

    useEffect(() => {
      setLocalValue(value || '')
    }, [value])

    return (
      <Box {...containerProps}>
        <MantineTextArea
          ref={ref}
          className={classes.textarea}
          onChange={handleChange}
          radius={8}
          value={localValue}
          {...props}
        />
      </Box>
    )
  },
)
